import { render, staticRenderFns } from "./TabelaJuizo.vue?vue&type=template&id=c8077316&scoped=true&"
import script from "./TabelaJuizo.vue?vue&type=script&lang=js&"
export * from "./TabelaJuizo.vue?vue&type=script&lang=js&"
import style0 from "./TabelaJuizo.vue?vue&type=style&index=0&id=c8077316&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8077316",
  null
  
)

export default component.exports